import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPromo } from '../../actions/cartActions.jsx';
import { useNavigate } from 'react-router-dom';
import { findUser } from '../../actions/userActions.jsx';
import arrow from '../../styles/img/arrow/arrow.svg';
import tiret_coupons from '../../styles/img/tiret_coupons.svg';
import promo1 from '../../styles/img/1sur3.svg';
import promo2 from '../../styles/img/2sur3.svg';
import promo3 from '../../styles/img/3sur3.svg';
import promoadd from '../../styles/img/promoadd.svg';
import useAxios from '../../axios/useAxios';

const PromoCard = ({ cartItems, promo }) => {
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { loading } = useSelector((state) => state.user);
  const { store } = useSelector((state) => state.store);
  const [promoCode, setPromoCode] = useState();
  const { loadingPromos } = useSelector((state) => state.cart);
  const [isPopupVisible, setIsPopUpVisible] = useState(false);
  const activatedPromoRef = useRef(false);

  const usedPromoRef = useRef(999);
  const [inscription, setInscription] = useState(true);
  const [mailvisible, setMail] = useState(false);
  const [inputpassword, setPassword] = useState('');
  const [unmatch, setUnmatch] = useState([]);
  const usedPromo =
    user.usedPromo && user.usedPromo.length > 0 ? [...user.usedPromo] : {};
  const [inputemail, setEmail] = useState('');

  const initialWelcomePromoo = [
    {
      name: 'promo1e',
    },
    {
      name: 'promo2e',
    },
    {
      name: 'promo5e',
    },
  ];

  const welcomeCurrentPromo =
    user && user.currentPromo
      ? user.currentPromo.filter((item) => item.type === 'welcome')
      : [];
  welcomeCurrentPromo.sort((a, b) => a.name.localeCompare(b.name));

  function areAllElementsIncluded(array1, array2) {
    const countMap1 = new Map();
    const countMap2 = new Map();

    // Remplir la première carte de comptage
    array1.forEach((element) => {
      countMap1.set(element, (countMap1.get(element) || 0) + 1);
    });

    // Remplir la deuxième carte de comptage
    array2.forEach((element) => {
      countMap2.set(element, (countMap2.get(element) || 0) + 1);
    });

    // Vérifier que chaque élément du tableau 1 est inclus dans le tableau 2 avec suffisamment d'occurrences
    return Array.from(countMap1.entries()).every(([element, count]) => {
      return countMap2.get(element) >= count;
    });
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    if (user && user._id) {
      dispatch(findUser(user, axiosInstance, navigate));
    }
  }, []);

  useEffect(() => {
    if (user && user._id) setIsPopUpVisible(false);
  }, [loading]);

  const applyPromo = (promoItem) => {
    activatedPromoRef.current = false;
    if (promoItem.name === 'promo5e' && !user._id) {
      setIsPopUpVisible(true);
    } else {
      dispatch(getPromo(cartItems, axiosInstance, promoItem));
    }
  };

  const checkUsed = (promoCode) => {
    const welcomePromo = user.currentPromo
      .filter((item) => item.type === 'welcome')
      .sort((a, b) => a.name.localeCompare(b.name));
    console.log(welcomePromo);
    if (welcomePromo && welcomePromo.length > 0) {
      return (
        parseFloat(promoCode.slice(5, -1)) <
          parseFloat(welcomePromo[0].name.slice(5, -1)) ||
        cartItems.promo === promoCode
      );
    } else return true;
  };

  const checkAvailable = (promoCode) => {
    console.log(
      user.currentPromo.some(
        (item) => item.type === 'welcome' && item.name === promoCode,
      ),
    );
  };

  const checkActivable = (subIndex, promo) => {
    const welcomePromo = user.currentPromo
      .filter((item) => item.type === 'welcome')
      .sort((a, b) => a.name.localeCompare(b.name));
    if (welcomePromo[0].name === promoCode) return true;
    else return false;
  };

  const checkCurrentActivable = (promoCode) => {
    if (user.currentPromo && user.currentPromo.length > 0) {
      const welcomePromo = user.currentPromo.filter(
        (item) => item.type === 'welcome',
      );
      if (welcomePromo && welcomePromo.length > 0) {
        welcomePromo.sort((a, b) => a.name.localeCompare(b.name));
        console.log(welcomePromo[0]);
        console.log(promoCode);
        if (
          welcomePromo[0].name === promoCode ||
          parseFloat(promoCode.slice(5, -1)) <
            parseFloat(welcomePromo[0].name.slice(5, -1))
        )
          return false;
        else return true;
      } else return true;
    }
  };
  const actualWelcomePromo = user.currentPromo
    .filter((item) => item.type === 'welcome')
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <>
      {' '}
      {!user.currentPromo || Object.keys(user.currentPromo).length < 1 ? (
        <></>
      ) : (
        <>
          <div className="promoscreen bottom-padding">
            <div
              className={
                loadingPromos
                  ? 'promoscreen_loading promoscreen_box gap-6'
                  : 'promoscreen_box gap-6'
              }
            >
              {/* PROMOTION DE BIENVENUE */}
              <div className="container_promos_welcome ">
                {initialWelcomePromoo.map((promoItem, index) => {
                  const delay = index * 0.5;
                  return (
                    <>
                      {checkAvailable(promoItem.name)}

                      <ul
                        className={`![animation-delay:_'+${delay}+'s] welcome_promo_card${checkCurrentActivable(promoItem.name) ? ' unactivable blockedSkin ' : ' activable scale2'}${checkUsed(promoItem.name) ? 'used ' : ''}`}
                      >
                        <div className="promologo">
                          {checkUsed(promoItem.name) ? (
                            <img src={promoadd} alt="" />
                          ) : (
                            <img
                              src={
                                index === 0
                                  ? promo1
                                  : index === 1
                                    ? promo2
                                    : promo3
                              }
                              className={
                                index > 0 ? 'promo_piece_translate_y' : ''
                              }
                              alt=""
                            />
                          )}
                        </div>
                        <li className={`flex flex-col`}>
                          <div
                            className={`${checkUsed(promoItem.name) ? ' promo_visit_texte light' : 'promo_visit_texte '}`}
                          >
                            {/* {promoItem.description} */}
                            {index === 0
                              ? '1ère visite'
                              : index === 1
                                ? '2éme visite'
                                : '3éme visite'}
                          </div>

                          <div className="promo_offert_box">
                            {checkUsed(promoItem.name) ? (
                              <></>
                            ) : (
                              <>
                                <h1
                                  className={`promo_offert_price${checkCurrentActivable(promoItem.name) ? ' unactivable ' : ''}`}
                                >
                                  {promoItem.name.slice(5).replace('e', '€')}
                                </h1>
                                <span className="promo_offert_title">
                                  Offert
                                </span>
                              </>
                            )}
                          </div>
                        </li>
                      </ul>
                    </>
                  );
                })}
              </div>

              <div className="promo_scan_check_text ">
                <div>
                  <img
                    src={
                      actualWelcomePromo[0].name === 'promo1e'
                        ? promo1
                        : actualWelcomePromo[0].name === 'promo2e'
                          ? promo2
                          : promo3
                    }
                    className="promo_piece_translate_y"
                    alt=""
                  />
                </div>
                <div className="flex w-full flex-col h-full justify-between">
                  <label>
                    visite
                    {actualWelcomePromo[0].name === 'promo1e'
                      ? '1 '
                      : actualWelcomePromo[0].name === 'promo2e'
                        ? '2 '
                        : '3 '}
                  </label>
                  <div>
                    {' '}
                    N’oublie pas qu'à ta Prochaine visite, tu auras
                    {user.currentPromo.filter((item) => item.type === 'welcome')
                      .length > 0 ? (
                      <>
                        <span>
                          {
                            user.currentPromo
                              .filter((item) => item.type === 'welcome')
                              .sort((a, b) => a.name.localeCompare(b.name))[0]
                              .name[5]
                          }
                          €
                        </span>{' '}
                        offert
                      </>
                    ) : (
                      ' offert'
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* PROMOTION CADEAUX */}

            {/* <div className='w-full'>

      { promoCadeaux()
        .sort((a, b) => a.name.localeCompare(b.name))
        .map((promoItem, index) => {
        const delay= index*0.5

      return(

        <>
        <ul  onClick={() => applyPromo(promoItem.name)} className={index>=0?'![animation-delay:_'+delay+'s] w-full appear transform translate-x-[120%] ':' w-full apparition'}>
          <li>
            <div className={cartItems.promo === promoItem.name && !activatedPromoRef.current? `coupons active` : "coupons"}>
              <div className="offert text-2xl  flex flex-col  items-center ml-3  justify-center">
                <h1 className='geomanistBold text-[28px]'>{promoItem.name.slice(5).replace('e', '€')}</h1><span className='text-[12px]'>Offert</span>
              </div>
              <img src={tiret_coupons} alt="" />
              <div className='offert2 flex flex-col gap-2 w-full'>
                <div className='flex flex-col gap-2  '>
                  <div className='geomanistBold text-[1.7rem]'>
                    Réductions
                  </div>
                  <span className='text-[14px] font-bold geomanistLight'>
                    {promoItem.description}
                  </span>
                </div>
              </div>
              <span className={`${cartItems.promo === promoItem.name && !activatedPromoRef.current ? '' : 'payer'} text-[1.7rem] w-[200px]  geomanistMedium py-8 p-4`}>
                                {cartItems.promo === promoItem.name && !activatedPromoRef.current?<>désactiver</>:<> J'active</>}
              </span>
              {cartItems.promo === promoItem.name && !activatedPromoRef.current?
              <>
                {activatedPromoRef.current = true}


              </>
                :
                  <>
                  </>
              }
            </div>
          </li>
       </ul>
          </>
    )
      })}</div> */}
          </div>
        </>
        //   )}
        // </>
      )}
    </>
  );
};

export default PromoCard;
